import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Card, Avatar, Rate } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { getContentWrapperStyle } from '../templateStyles';

const { Title, Text, Paragraph } = Typography;

export default function SectionTestimonial({ section, siteInfo }) {
  const { t } = useTranslation();
  const quotes = section.config?.quotes || [];
  const [active, setActive] = useState(0);

  useEffect(() => {
    if (quotes.length <= 1) return;
    const id = setInterval(() => setActive(i => (i + 1) % quotes.length), 5000);
    return () => clearInterval(id);
  }, [quotes.length]);

  if (quotes.length === 0) return null;

  const q = quotes[active];
  const brandColor = siteInfo?.brand_color || '#1890ff';
  const template = siteInfo?.site_template || 'modern';
  const isMinimal = template === 'minimal';
  const isClassic = template === 'classic';

  const cardRadius = isMinimal ? 0 : isClassic ? 4 : 12;
  const sectionBg = isMinimal ? '#fff' : isClassic ? '#f5f5f5' : '#f8f9fa';
  const contentFont = getContentWrapperStyle(template, brandColor);

  return (
    <div style={{
      background: sectionBg,
      padding: '48px 24px',
      ...contentFont,
      borderTop: isMinimal ? '1px solid #e8e8e8' : 'none',
      borderBottom: isMinimal ? '1px solid #e8e8e8' : 'none',
    }}>
      <Title level={2} style={{
        textAlign: isMinimal ? 'left' : 'center',
        marginBottom: 32,
        fontWeight: isMinimal ? 300 : 600,
        letterSpacing: isMinimal ? 1 : 0,
        borderBottom: isMinimal ? `2px solid ${brandColor}` : 'none',
        paddingBottom: isMinimal ? 8 : 0,
        display: isMinimal ? 'inline-block' : 'block',
      }}>
        {section.title || t('sections.testimonial.title')}
      </Title>
      <div style={{ maxWidth: 700, margin: '0 auto', textAlign: 'center' }}>
        <Card style={{
          borderRadius: cardRadius,
          borderTop: isMinimal ? 'none' : `3px solid ${brandColor}`,
          border: isMinimal ? '1px solid #e8e8e8' : undefined,
          boxShadow: isMinimal ? 'none' : isClassic ? '0 1px 4px rgba(0,0,0,0.08)' : '0 2px 8px rgba(0,0,0,0.1)',
        }}>
          <div style={{ fontSize: 48, color: brandColor, lineHeight: 1, marginBottom: 16 }}>"</div>
          <Paragraph style={{ fontSize: 16, lineHeight: 1.8, marginBottom: 16 }}>{q.text}</Paragraph>
          {q.rating && <Rate disabled defaultValue={q.rating} style={{ marginBottom: 12 }} />}
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 12 }}>
            <Avatar src={q.avatar_url} icon={<UserOutlined />} size={40} />
            <div style={{ textAlign: 'left' }}>
              <Text strong>{q.author}</Text>
              {q.company && <div><Text type="secondary" style={{ fontSize: 12 }}>{q.company}</Text></div>}
            </div>
          </div>
        </Card>
        {quotes.length > 1 && (
          <div style={{ marginTop: 16, display: 'flex', justifyContent: 'center', gap: 8 }}>
            {quotes.map((_, i) => (
              <span key={i} onClick={() => setActive(i)}
                style={{
                  width: 8, height: 8,
                  borderRadius: isMinimal ? 0 : '50%',
                  background: i === active ? brandColor : '#ccc',
                  cursor: 'pointer',
                }}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
